/**
 * Rotulos dos papeis.
 *
 * Os valores gravados no banco sao 'Administrador', 'Manutencao' e 'Padrao',
 * presos por uma constraint e comparados no codigo do servidor. Acentuar o
 * dado quebraria o sistema, entao a acentuacao vive apenas na exibicao.
 */
export const ROLE_LABELS = {
  Administrador: 'Administrador',
  Manutencao: 'Manutenção',
  Padrao: 'Padrão',
  Auditoria: 'Auditoria',
};

export function roleLabel(role) {
  return ROLE_LABELS[role] || role || '';
}

/**
 * Perfil somente leitura. O servidor recusa qualquer escrita deste papel
 * (403 READ_ONLY_ROLE); aqui a checagem existe para nao oferecer botao que
 * so produziria erro.
 */
export function isSomenteLeitura(user) {
  return user?.role === 'Auditoria';
}
